module.exports = {
  formatDate(date) {
    let d = new Date(date);

    if (d.getFullYear() > 3000) {
      return "-";
    }

    let dateString = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();

    return dateString;
  },
  formatSize(size) {
    if (!size) {
      return "-";
    }

    return parseFloat(size).toFixed(1) + " MB";
  },
  formatSubscriptionTier(tier) {
    if (tier === 1) {
      return "Professional";
    }
    else if (tier === 2) {
      return "Businses";
    }
    else if (tier === 3) {
      return "Free";
    }
    else if (tier === 4) {
      return "Enterprise";
    }
    else {
      return "Unknown";
    }
  },
  formatSubscriptionType(type) {
    if (type === "M")
    {
      return "Monthly";
    }

    if (type === "Y")
    {
      return "Yearly";
    }

    return "-";
  },
  formatSubscriptionLimit(limit) {
    if (limit === 99999) {
      return "unlimited";
    }

    return limit + "";
  },
  formatUserRole(userRoleString) {
    let userRoleInt = parseInt(userRoleString);

    return userRoleInt === 2 ? "Grand" : userRoleInt === 1 ? "Admin" : "User";
  },
  formatModelFormat(format) {
    switch (format.toLowerCase()) {
      case 'fbx': return "FBX";
      case 'gltf': return "gLTF";
      case 'glb': return "GLB";
      default: return format.toUpperCase();
    }
  },
};
